import { useCallback, useEffect, useRef } from 'react';

const events = [
  'click',
  'mousemove',
  'wheel',
  'keypress',
  'scroll',
  'touchstart',
  'touchmove',
  'touchend',
];

export const useIdleHook = (timeout: number, onIdle: () => void) => {
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

  const resetTimeout = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(onIdle, timeout);
  }, [onIdle, timeout]);

  useEffect(() => {
    resetTimeout();

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [resetTimeout]);

  useEffect(() => {
    events.forEach((event) =>
      window.addEventListener(event, resetTimeout, { passive: true }),
    );

    return () => {
      events.forEach((event) =>
        window.removeEventListener(event, resetTimeout),
      );
    };
  }, [resetTimeout]);
};
